import { Component, OnInit } from '@angular/core';
import { VisitType } from '../../models/visit-type';
import { VisitTypeService } from '../../services/visit-type-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-visit-type',
  templateUrl: './add-visit-type.component.html',
  styleUrls: ['./add-visit-type.component.scss'],
})
export class AddVisitTypeComponent implements OnInit {
  sType: VisitType;
  isEdit = false;
  isLoading: boolean = false;
  constructor(
    private service: VisitTypeService,
    private diag: NbDialogRef<AddVisitTypeComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {
    this.sType = {} as VisitType;
    this.sType.name = '';
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  save() {
    this.isLoading = true;
    if (!this.isEdit)
      this.service.post(this.sType).subscribe((res) => {
        this.isLoading = false;
        this.toast.show('تم إضافة نوع زيارة جديد بنجاح', '', { status: 'success', duration: 4000 });
        this.diag.close('true');
      });
    else {
      this.service.put(this.sType.id, this.sType).subscribe((res) => {
        this.isLoading = false;
        this.toast.show('تم تعديل نوع زيارة بنجاح', '', { status: 'success', duration: 4000 });
        this.diag.close('true');
      });
    }
  }
}
